<template>
    <div class="devices-list__block" v-if="deviceData">
        <device-status :device="deviceData" :showLocation="showLocation" :edit="edit"/>
        <v-layout row class="devices-list__block__title" :class="{'device-btns-edit': edit}">
            <device-title :device="deviceData"></device-title>
        </v-layout>
        <v-btn class="main-text btn-grey mt-3" @click="openRemote" :disabled="!free">
            Открыть пульт
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "TVDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
        free: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
            room: null,
        };
    },
    created() {
        this.deviceData = this.device;
        this.room = this.$route.params.id;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
    methods: {
        openRemote() {
            // this.$router.push({ name: 'deviceTV', params: { device: this.deviceData.uid, room: this.room } });
        }
    },
}
</script>